<template>
  <div>
    <router-link to="/articlesShare?articleId=775">分享文章775</router-link> <br />
    <router-link to="/articlesShare?articleId=773">分享文章773</router-link> <br />
    <router-link to="/articlesShare?articleId=771">分享文章771</router-link> <br />
    <router-link to="/articlesShare?articleId=769">分享文章769</router-link> <br />
    <!-- <router-link to="/articlesShare2?articleId=514">分享文章514</router-link> <br /> -->
    <br />
    <router-link to="/videoShare/11">分享视频</router-link>
    <br />
    <router-link to="/appShare">分享APP</router-link>
    <br />
    <router-link to="/aboutApp">了解鹏扬</router-link>
    <br />
    <router-link to="/jimiRule">基米规则</router-link>
    <br />
    <router-link to="/qualifications">相关资质</router-link>
    <br />
    <router-link to="/instructions">使用说明</router-link>
    <br />
    <router-link to="/weappQRCode">生成二维码</router-link>
    <br />
    <router-link to="/JimiMallRule">基米商城规则</router-link>
    <br />
    <router-link to="/emergencyText">客户应急处理提示</router-link>
  </div>
</template>
<script>
export default {
  name: '',
  data () {
    return {}
  },
  methods: {}
}
</script>
<style
  lang="scss"
  scoped
>
</style>



// WEBPACK FOOTER //
// src/views/h5/Nav.vue